var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FlotoDownloadLink',{attrs:{"file-name":((_vm.resource.name) + ".pdf"),"url":_vm.printUrl},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var downloading = ref.downloading;
return [(!downloading)?_c('MIcon',{staticClass:"action-menu-icon",attrs:{"name":"print"}}):_vm._e(),_c('span',{staticClass:"ml-1 action-menu-text"},[_vm._v(" "+_vm._s(_vm.$t('print'))+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }